var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarInBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 7,
    fill: "#4B9BF5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.25 11.75H21.6667V10.5833C21.6667 10.2614 21.4053 10 21.0833 10H20.5C20.178 10 19.9167 10.2614 19.9167 10.5833V11.75H14.0833V10.5833C14.0833 10.2614 13.822 10 13.5 10H12.9167C12.5947 10 12.3333 10.2614 12.3333 10.5833V11.75H11.75C10.7852 11.75 10 12.5352 10 13.5V22.25C10 23.2148 10.7852 24 11.75 24H22.25C23.2148 24 24 23.2148 24 22.25V13.5C24 12.5352 23.2148 11.75 22.25 11.75ZM22.8333 22.25C22.8333 22.5714 22.5714 22.8333 22.25 22.8333H11.75C11.4286 22.8333 11.1667 22.5714 11.1667 22.25V15.8567H22.8333V22.25Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarInBlue);
export default __webpack_public_path__ + "static/media/calendar-in-blue.375e86fce9baa29a0f2a69576859fb01.svg";
export { ForwardRef as ReactComponent };